module.exports = "https://static.wanderu.com/static/media/gb.a3e6d90f.svg";